import Loading from '../../../../Dashboards/Common/Loading';
import { AnnualEvolutionRegisters } from './AnnualEvolutionRegisters';
import { useRegistersChartsDataContext } from './hooks/useRegistersChartsDataContext';
import { Indicators } from './Indicators';
import { TableMonthlyEvolutionRegisters } from './TableMonthlyEvolutionRegisters';
import { MonthlyEvolutionRegisters } from './MonthlyEvolutionRegisters';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useRegistersChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="side-by-side-group">
                <Indicators />
                <div className="right-group-registers">
                    <MonthlyEvolutionRegisters />
                </div>
            </div>
            <div className="charts-side-by-side-dashboards">
                <AnnualEvolutionRegisters />
                <TableMonthlyEvolutionRegisters />
            </div>
        </>
    );
};
